import IconLabel from './IconLabel';

export default IconLabel;
